define('modules/integrations/index',['require','exports','module','./router'],function(require, exports, module) {
  "use strict";

  var Router = require("./router");

  module.exports = {
    init: function() {
      new Router();
    }
  };
});

